import styled from "styled-components";

export const PaymentPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #f5f5f5;
  overflow: hidden;
  overflow-y: auto;
`;
export const PaymentPageTopBar = styled.div`
  display: flex;
  align-items: center;
  .bar_title {
    display: flex;
    flex-grow: 1;
  }
`;
